import { render, staticRenderFns } from "./scheduleProvider.vue?vue&type=template&id=188e1fb2&scoped=true"
import script from "./scheduleProvider.vue?vue&type=script&lang=js"
export * from "./scheduleProvider.vue?vue&type=script&lang=js"
import style0 from "./scheduleProvider.vue?vue&type=style&index=0&id=188e1fb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "188e1fb2",
  null
  
)

export default component.exports